import to from 'await-to-js';
import { generateQueryParameter } from 'utils/generateQueryParameter';
import { api } from '.';

import { planUsageAdaptor } from 'adaptors/plans/plan-usage.adaptor';
import { getShopInfoAdaptor } from 'adaptors/shop/shop-info';
import { getPlanUsage } from 'rest/dist/gen/api/pricing/pricing';
import { getShopInfo as ApiGetShopInfo, getShopStorage } from 'rest/dist/gen/api/shops/shops';

export const getShopInfo = async (callback) => {
  const [error, response] = await to(ApiGetShopInfo());
  const [erroronboard, responseonboard] = await to(getShopStorage());
  if (response) {
    const data = { data: getShopInfoAdaptor(response.data, responseonboard?.data) };

    callback(true, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const getNotifications = async (filter, callback) => {
  const params = await generateQueryParameter(filter);
  const [error, response] = await to(api.getNotifications(params));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const setNotificationClose = async (data, callback) => {
  const [error, response] = await to(api.setNotificationClose(data));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const setNotificationView = async (data, callback) => {
  const [error, response] = await to(api.setNotificationView(data));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const getShopPlanInfo = async (callback) => {
  const [error, response] = await to(api.getShopPlanInfo());
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};

export const getPermission = async (callback) => {
  const [error, response] = await to(getPlanUsage());
  if (response) {
    const data = planUsageAdaptor(response);
    callback(true, data);
  }
  if (error) {
    callback(false, error);
  }
};

export const getOption = async (filter, callback) => {
  const params = await generateQueryParameter(filter);
  const [error, response] = await to(api.getOption(params));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const getPlans = async (callback) => {
  const [error, response] = await to(api.getPlans());
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const getPlansWithDiscount = async (filter, callback) => {
  var filtercode = filter.discountCode;
  const params = await generateQueryParameter(filter);
  const [error, response] = await to(api.getPlansWithDiscount(filtercode));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};

export const getShopSetting = async (callback) => {
  const [error, response] = await to(api.getShopSetting());
  if (response) {
    const data = response.data;
    callback(response.data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const saveShopSetting = async (data, callback) => {
  const [error, response] = await to(api.saveShopSetting(data));
  if (response) {
    const data = response.data;
    callback(true, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const callSaveShopSetting = async (data, callback) => {
  const [error, response] = await to(api.saveShopSetting(data));

  if (error || response.error) {
    return {
      success: false,
      data: error || response,
    };
  }

  if (response) {
    const data = response.data;
    return {
      success: true,
      data,
    };
  }
};
export const wasItHelpful = async (data, callback) => {
  const [error, response] = await to(api.wasItHelpful(data));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const sendSupportEmail = async (data, callback) => {
  const [error, response] = await to(api.sendSupportEmail(data));
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};
export const getFaqList = async (callback) => {
  const [error, response] = await to(api.getFaqList());
  if (response) {
    const data = response.data;
    callback(data.success, data);
  }
  if (error) {
    callback(false, error);
  }
};

